export default __webpack_public_path__ + "static/media/Bhishma.4ece8c0f.png";